import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { ButtonLink } from './ui/Button';
import { contactDetails, WAYDEV_CONTACT_URL } from '../data/contact';
export function Contact() {
  return <section id="contact" className="on-ink bg-ink py-[clamp(66px,9vw,114px)] text-bone" data-id="element-32" data-mp="315s2ucm38mab">
      <div className="mx-auto max-w-shell px-[clamp(20px,5vw,64px)]" data-id="element-33" data-mp="2w8igx6xwqsr8">
        <SectionReveal data-id="element-34" data-mp="3sxhr4ri1y4m2">
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-bone/50" data-id="element-35" data-mp="3sxzm7kszacse">
            05<span className="pl-2" data-id="element-36" data-mp="3ovw5agnjifzq">Enquiries</span>
          </p>

          <div className="mt-[26px] grid grid-cols-1 items-start gap-[clamp(28px,5vw,72px)] md:grid-cols-2 md:items-end" data-id="element-37" data-mp="3oyieekq2x3k2">
            <div data-id="element-38" data-mp="3f6urmx4gwaox">
              <h2 className="font-serif text-[clamp(28px,3.9vw,46px)] font-medium leading-[1.08] tracking-[-0.02em] text-bone" data-id="element-39" data-mp="3f59wp6e8qpqj">
                Start with the question, not the tool.
              </h2>
              <p className="mt-5 max-w-[48ch] text-bone/70" data-id="element-40" data-mp="bokyc7otamby">
                I take on a small number of advisory engagements each year and
                select them personally. Send the problem in two or three
                sentences through the Waydev contact desk and it reaches me. If
                Waydev is the answer I will say so. If it is not, I will tell
                you that too, and point you somewhere better.
              </p>
              <div className="mt-[30px]" data-id="element-41" data-mp="3f2i4k586db2k">
                <ButtonLink variant="inverted" href={WAYDEV_CONTACT_URL} target="_blank" rel="noopener noreferrer" data-id="element-42" data-mp="3141y8fe85mky">
                  Submit an enquiry
                </ButtonLink>
              </div>
              <p className="mt-5 max-w-[42ch] font-mono text-[11px] uppercase leading-[1.6] tracking-[0.12em] text-bone/40" data-id="element-43" data-mp="2w58j6ijahnio">
                Every enquiry is read personally. Expect a reply only where
                there is a genuine fit.
              </p>
            </div>

            <dl className="w-full" data-id="element-44" data-mp="23bkdcn2rz76h">
              {contactDetails.map(detail => <div key={detail.key} className="flex flex-wrap gap-x-4 gap-y-1 border-t border-bone/20 py-3 text-[14.5px]" data-id="element-45" data-mp="2397r3xpzianm">
                  <dt className="min-w-[100px] shrink-0 pt-0.5 font-mono text-[11px] uppercase tracking-[0.12em] text-bone/50" data-id="element-46" data-mp="1ub5sfotq3u3i">
                    {detail.key}
                  </dt>
                  <dd className="text-bone/80" data-id="element-47" data-mp="2m1k0v5iywe7s">
                    {detail.href ? <a href={detail.href} target="_blank" rel="noopener noreferrer" className="border-b border-signal pb-0.5 no-underline transition-opacity duration-200 ease-editorial hover:opacity-70" data-id="element-48" data-mp="2i1rp6jya1ry7">
                        {detail.value}
                      </a> : detail.value}
                  </dd>
                </div>)}
            </dl>
          </div>
        </SectionReveal>
      </div>
    </section>;
}